<template>
  <div class="tabulator-main">
    <div v-if="pTableData.length > 0" class="total-records">
      <span v-if="pSelectedRow.length > 0">
        Selected {{ pSelectedRow.length }} of {{ pTableData.length }}
        <span>
          <button class="clear-selected" @click="clearAllSelectedRow()">Clear Selected</button>
        </span>
      </span>
      <div v-else style="color: transparent; padding: 1px 0">Nothing to show</div>

      Total {{ totalCount }} records (Page {{ currentPage }} of {{ maxPage }})
      
      <div class="title-filters-area">
        <div class="title">
          <div style="margin-right: 3px">{{ tableTitle }}</div>
          <div id="downloadPrintDropdown" class="button-download-print dropup" title="Download or Print" data-toggle="dropdown">
            <img src="https://img.icons8.com/android/24/000000/download.png"/>
            <div>/</div>
            <img src="https://img.icons8.com/android/24/000000/print.png"/>
          </div>

          <div class="dropdown-menu download-print-menu">
            <div class="print-download-menu" @click="printDownload('print')">
              <img src="https://img.icons8.com/office/80/000000/print.png"/>
              <div>Print</div>
            </div>
            <div class="print-download-menu" @click="printDownload('csv')">
              <img src="https://img.icons8.com/office/80/000000/csv.png"/>
              <div>Download CSV</div>
            </div>
            <div class="print-download-menu" @click="printDownload('xlsx')">
              <img src="https://img.icons8.com/office/80/000000/xls.png"/>
              <div>Download XLSX</div>
            </div>
            <!-- <div class="print-download-menu" @click="printDownload('pdf')">
              <img src="https://img.icons8.com/office/80/000000/pdf.png"/>
              <div>Download PDF</div>
            </div> -->
          </div>
        </div>
        <div v-if="currentFilter.length > 0" class="filters">
          <div class="top">
            Filters : Showing {{ filterCount }} of {{ totalCount }} results <button @click="showMore = !showMore" class="show-more-btn">{{ showMore ? 'Close' : 'Show more' }}</button>
          </div>
          <div v-if="showMore">
            <div v-for="(f, i) in currentFilter" :key="i">{{ f.field }} {{ f.type.toString().length > 2 ? '=' : f.type }} {{ f.value }}</div>
            <button @click="clearFilters()" class="show-more-btn" style="margin: 0; margin-top: 3px">Clear Filters</button>
          </div>
        </div>
      </div>
    </div>

    <div v-if="pTableData.length <= 0" style="width: 100%; display: flex; justify-content: center">No Records found</div>
    <div :id="tableID.split(' ').join('_')"></div>
  </div>
</template>

<script>
/* eslint-disable */
export default { // OBSOLETE COMPONENT (Use TableBox.vue instead)
  data: function() {
    return {
      pTableData: [],
      currentFilter: [],
      maxPage: 0,
      filterCount: 0,
      table: null,
      pSelectedRow: [],
      pCurrentRowSize: 0,
      totalCount: 0,
      showMore: false
    }
  },
  props: {
    rowsCount: { type: Array, default: function() { return [ '10', '20', '30', '40', '50', 'All' ] } },
    rowsCountBtn: { type: Array, default: function() { return [] } },
    numberColumns: { type: Array, default: function() { return [] } },

    // public properties
    tableTitle: { type: String, default: '' }, // Set the title of the tabulator
    tableData: { type: Array, default: function() { return [] } }, // The data to populate in the table
    selectedRow: { type: Array, default: function() { return [] } }, // Array of all the selected row
    multiSelect: { type: Number, default: -1 }, // -1, unlimited selection; 0, disable selection, n>0, max selection == n
    rollingSelection: { type: Boolean, default: true }, // Set to false to disable auto deselect the first selected row if max number of selected row reached
    tableDisabled: { type: String, default: '' }, // Set any message to disable tabulator selection with message
    headerDisabled: { type: String, default: '' }, // Set any message to disable tabulator header with message
    rowFormatter: { type: Array, default: function() { return [] } }, // Set the current formatter (BETA)
    currentPage: { type: Number, default: 1 }, // The current page that you are on
    currentRowSize: { type: Number, default: 0 }, // The current number of rows in a page that you are on
    additionalColumn: { type: Array, default: function() { return [] } }, // Add additional column for button or icon. An array of object eg: { value: 'Your desired text to show / img src for icon type', type: 'Currently support button and icon only', index: 'The index of the column placement' }
    frozenColumn: { type: String, default: '' }, // The column name or key of the object to freeze when scrolling horizontally
    tableID: { type: String, default: 'tabulator' }, // Set the unique ID of the tabulator only if you have multiple tabulator in a single page/file
    hideColumns: { type: Array, default: function() { return [] } }, // Array of columns' name to hide - Array of string
    showDateOnlyColumns: { type: Array, default: function() { return [] } }, // Array of string of columns name to only show date without time (For date columns)
    cancelAllTabIndex: { type: Boolean, default: false }, // Set this to true is you don't want any tab index in the tabulator (currently main use is for InputQuery to make sure that the tab will go to the next element in the page)
    groupBy: { type: Array, default: null },

    // Deprecated props. Use tableDisabled or headerDisabled instead
    disabled: { type: Boolean, default: false }, // Set true to disable the tabulator selection (No message shown)
    disableMessage: { type: String, default: '' }, // Set any message to disable tabulator selection with message

    // public events
    // @rowSelected - fired when a row is selected, returns the row object when selected, null when deselected
    // @rowDblClick - fired when a row is double clicked, returns the object of the row
    // @cellButtonClick - fired when a button in a cell is clicked, returns the button value and row object

    // Public Methods
    // selectRow(index) - select the row at the specific index

    // Temp Workaround for BatchBacking MultiSelect
    rowSelectedPer: { type: Array, default: function() { return [] } },
  },
  components: {
  },
  methods: {
    loadTable: function(val) {
      if (val.length > 0) {
        this.pTableData = val;
        var columns = [];
        var hasType = val[0]['#'] == 0;
        
        if (hasType) {
          var isNumbers = Object.keys(val[0]).map((k) => { 
            var item = val[0][k].toString().split('|');
            return item[0].toLowerCase() == 'number' ? k : null;
          });
          this.numberColumns = isNumbers.filter((c) => { return c });

          Object.keys(val[0]).forEach((k) => {
            var value = val[0][k].toString().split('|');
            
            if (value[0].toLowerCase() == 'string') {
              columns.push({ title: k, field: k, headerFilter: this.stringEditor, headerFilterParams: k,
                formatter: this.cellFormatter, formatterParams: { icon: value[1] ? value[1] : '', button: value[2] ? value[2] : '' } });
            } else if (value[0].toLowerCase() == 'number') {
              columns.push({ title: k, field: k, headerFilter: this.numberRangeEditor, width: '15px', headerFilterParams: k,
                formatter: this.cellFormatter, formatterParams: { icon: value[1] ? value[1] : '', button: value[2] ? value[2] : '' } });
            } else if (value[0].toLowerCase().includes('date')) {
              columns.push({ title: k, field: k, headerFilter: this.dateRangeEditor, width: '14px', headerFilterParams: k,
                formatter: this.cellFormatter, formatterParams: { icon: value[1] ? value[1] : '', button: value[2] ? value[2] : '' } });
            } else {
              columns.push({ title: k, field: k,
                formatter: this.cellFormatter, formatterParams: { icon: value[1] ? value[1] : '', button: value[2] ? value[2] : '' } });
            }
          });
        } else {
          Object.keys(val[0]).forEach((k) => {
            var value = val[0][k] ? val[0][k].toString().split('|') : '';
            // k = { field: "My Field", icon: "/Help.png", button: "" }
            columns.push({ title: k, field: k, headerFilter: this.stringEditor, headerFilterParams: k,
              formatter: this.cellFormatter, formatterParams: { icon: value[1] ? value[1] : '', button: value[2] ? value[2] : '' } });
            
            // columns.push({ title: k, field: k, headerFilter: this.stringEditor,
            //   headerFilterParams: k });
            // columns.push({ title: k, field: k, headerFilter: 'input', headerFilterPlaceholder: k,
            //   headerFilterFunc: this.filterFunction, headerFilterFuncParams: k });
          });
        }

        this.additionalColumn.forEach((a) => {
          switch (a.type) {
            case 'button':
              columns.splice(a.index, 0, {
                formatter: this.cellFormatter, formatterParams: { button: a.value, buttonIcon: a.icon }, frozen: a.frozen
              });
              break;
            case 'icon':
              columns.splice(a.index, 0, {
                formatter: this.cellFormatter, formatterParams: { icon: a.value }
              });
              break;
          }
        });

        var selectable;
        if (this.multiSelect == -1) {
          selectable = true;
        } else if (this.multiSelect == 0) {
          selectable = false;
        } else if (this.multiSelect == 1) {
          selectable = 1;
        } else {
          selectable = this.rollingSelection ? parseInt(this.multiSelect) : parseInt(this.multiSelect) + 1;
        }

        this.table = null;
        this.pSelectedRow = [];
        this.$emit('update:selectedRow', this.pSelectedRow);
        this.table = new Tabulator(`#${this.tableID.split(' ').join('_')}`, {
          columns: columns,
          // rowFormatter: this.rowFormatter,
          pagination: 'local',
          printAsHtml: true,
          printStyled: true,
          printHeader: `<h3>${this.tableTitle}<h3>`,
          // printFooter: `<h5>${this.tableTitle}<h5>`,
          paginationSize: this.groupBy ? this.pTableData.length * (this.groupBy.length + 1) : this.pTableData.length,
          movableColumns: true,
          selectable: selectable,
          selectableRollingSelection: this.rollingSelection,
          footerElement: this.getFooterElement(),
          pageLoaded: this.pageChanged,
          rowSelected: this.rowSelected,
          rowDeselected: this.rowDeselected,
          dataFiltered: this.dataFiltered,
          rowDblClick: this.doubleClick,
          dataLoaded: this.tableDataLoaded,
          groupBy: this.groupBy
        });

        this.hideColumns.forEach((h) => { this.table.hideColumn(h) });

        this.pCurrentRowSize = this.pTableData.length;
        this.$emit('update:currentRowSize', this.pCurrentRowSize);

        setTimeout(() => {
          this.maxPage = this.table.getPageMax();
        }, 10);

        this.totalCount = val.length;

        if (hasType) {
          this.totalCount--;
          var keys = Object.keys(val[0]);
          var values = Object.values(val[0]);

          var dateIndex = [];
          for (var i = 0; i < values.length; i++) {
            if (values[i].toString().toLowerCase().includes('date')) {
              dateIndex.push(i);
            }
          }

          var data = val.filter((v => { return v['#'] != 0 }));

          data.forEach((d) => {
            dateIndex.forEach((i) => {
              var newDate = Date.parse(d[keys[i]]);
              var showDateOnly = this.showDateOnlyColumns.includes(keys[i]);
              if (newDate) {
                d[keys[i]] = this.$dateTime.getDateTime(new Date(newDate), showDateOnly ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm');
                d[`${keys[i]}_OBJ`] = new Date(newDate);
              } else {
                var dateInt = parseInt(d[keys[i]].toString().replace(/^\D+/g, ''));
                d[keys[i]] = this.$dateTime.getDateTime(new Date(dateInt), showDateOnly ? 'dd/MM/yyyy' : 'dd/MM/yyyy HH:mm');
                d[`${keys[i]}_OBJ`] = new Date(dateInt);
              }
            });
          });

          this.table.setData(data);
          return;
        }

        this.table.setData(val);

        this.tableScrollToTop(true);
      } else {
        if (this.table) {
          this.table.clearData();
        }
        var a = document.getElementById(this.tableID.split(' ').join('_'));
        a.innerHTML = '';
        a.className = '';
      }
      
      if (this.cancelAllTabIndex) {
        var main = document.getElementById(this.tableID.split(' ').join('_'));
        var allElements = Array.from(main.getElementsByTagName('*'));
        
        allElements.forEach((a) => {
          a['tabIndex'] = '-1';
        });
      }
    },

    getFooterElement: function() {
      var footer = `<span>Rows : </span>`;

      this.rowsCount.forEach((r) => {
        footer += `<button id='${r}_${this.tableID.split(' ').join('_')}' class='tabulator-page ${ r == 'All' ? 'active' : '' }'>${r}</button>`;
      });

      this.addClickEvent();
      
      return footer;
    },
    changeRowSize: function(e) {
      var size = e.target.id.split('_')[0];

      this.rowsCountBtn.forEach((b) => {
        b.className = 'tabulator-page';
      });

      e.target.className = 'tabulator-page active';

      if (size == 'All') {
        this.table.setPageSize(this.groupBy ? this.pTableData.length * (this.groupBy.length + 1) : this.pTableData.length);
        this.maxPage = 1;
        
        this.pCurrentRowSize = this.pTableData.length;
        this.$emit('update:currentRowSize', this.pCurrentRowSize);

        this.tableScrollToTop();
        return;
      }
      
      this.table.setPageSize(size);
      this.pCurrentRowSize = parseInt(size);
      this.$emit('update:currentRowSize', this.pCurrentRowSize);

      this.maxPage = this.table.getPageMax();

      this.tableScrollToTop();
    },
    addClickEvent: function() {
      setTimeout(() => {
        this.rowsCount.forEach((r) => {
          var btn = document.getElementById(`${r}_${this.tableID.split(' ').join('_')}`);

          btn.addEventListener('click', this.changeRowSize);

          if (r == 'All') {
            btn.style.marginRight = '20px';
          }

          this.rowsCountBtn.push(btn);
        });
      }, 10);
    },
    pageChanged: function(page) {
      this.currentPage = page;
      this.$emit('update:currentPage', this.currentPage);
      this.tableScrollToTop();
    },
    tableDataLoaded: function(data) {
      // console.log('DataLoaded');
    },
    rowSelected: function(row) {
      this.pSelectedRow.push(row._row.data);

      // Workaround for BatchBooking multirow select
      this.rowSelectedPer.push(row._row.data);
      //
      
      if (this.multiSelect > 0 && this.pSelectedRow.length > parseInt(this.multiSelect) && !this.rollingSelection) {
        this.$showAlert('error', 'Max selection reached', `Sorry, you are only allowed to select a maximum of ${this.multiSelect} rows only`);
        row.deselect();
      } else {
        this.$emit('rowSelected', row._row.data);
      }
    },
    rowDeselected: function(row) {
      // var deselect = this.pSelectedRow.filter((s) => s.itemID == row._row.data.itemID);
      
      // var index = this.pSelectedRow.indexOf(deselect[0]);

      // this.pSelectedRow.splice(index, 1);
      var index = this.pSelectedRow.indexOf(row._row.data);
      this.pSelectedRow.splice(index, 1);

      setTimeout(() => {
        if (this.pSelectedRow.length == 0) {
          this.$emit('rowSelected', null);
        }
      }, 5);
    },
    doubleClick: function(e, row) {
      this.$emit('rowDblClick', row._row.data);
    },
    dataFiltered: function(filters, rows) {
      this.filterCount = rows.length;
      if (this.table) {
        this.currentFilter = this.table.getFilters(true);
      }
    },
    clearFilters: function() {
      if (this.table) {
        this.table.clearFilter(true);
      }

      var tableChildNodes = document.getElementById(this.tableID.split(' ').join('_')).childNodes;
      if (tableChildNodes.length > 0) {
        var tableChild = tableChildNodes[0].children[0];
        var inputs = tableChild.getElementsByTagName('input');

        for (var i = 0; i < inputs.length; i++) {
          inputs[i].value = '';
        }
      }

      if (this.showMore) {
        this.showMore = false;
      }
    },

    // String Editor and Filter Function
    stringEditor: function(cell, onRendered, success, cancel, editorParams) {
      var container = document.createElement('span');

      var input = this.createInput({ type: 'text', id: editorParams, placeholder: editorParams }, {
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '11px',
        height: '20px',
        border: 'solid thin rgba(128,128,128,0.6)'
      });

      input.addEventListener('keyup', this.stringFiltering);

      container.appendChild(input);

      return container;
    },
    stringFiltering: function(e) {
      // var filterValue = e.target.value.split(',');
      var id = e.target.id;

      var filters = this.table.getFilters();

      var hasFilter = filters.filter((f) => { return f.field == id });

      // console.log('IN TABULATOR');
      // console.log(e.target.value);

      if (hasFilter.length > 0) {
        this.table.removeFilter(hasFilter[0].field, hasFilter[0].type, hasFilter[0].value);
      }

      if (!e.target.value) return;

      this.table.addFilter([
        { field: id, type: 'like', value: e.target.value }
      ]);

      // console.log(this.pTableData);
      // console.log(table.getFilters());
    },
    // String Editor and Filter Function

    // Number Editor and Filter Function
    numberRangeEditor: function(cell, onRendered, success, cancel, editorParams) {
      var container = this.createDiv('', {});

      var start = this.createInput({ type: 'number', id: `${editorParams}_start`, placeholder: 'Min' }, {
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '11px',
        height: '20px',
        border: 'solid thin rgba(128,128,128,0.6)',
      });

      var end = this.createInput({ type: 'number', id: `${editorParams}_end`, placeholder: 'Max' }, {
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '11px',
        height: '20px',
        border: 'solid thin rgba(128,128,128,0.6)',
      });

      container.appendChild(start);
      container.appendChild(document.createElement('br'));
      container.appendChild(end);

      start.addEventListener('keyup', this.numberFiltering);
      start.addEventListener('change', this.numberFiltering);
      end.addEventListener('keyup', this.numberFiltering);
      end.addEventListener('change', this.numberFiltering);

      return container;
    },
    numberFiltering: function(e) {
      var id = e.target.id;
      var value = e.target.value;
      var field = id.split('_');

      var filters = this.table.getFilters();
      
      if (id.includes('start')) {
        var hasMin = filters.filter((f) => { return f.field == field[0] && f.type == '>=' });

        if (hasMin.length > 0) {
          this.table.removeFilter(hasMin[0].field, hasMin[0].type, hasMin[0].value);
        }

        if (!value) return;

        this.table.addFilter([
          { field: field[0], type: '>=', value: Number(e.target.value) }
        ]);
      } else {
        var hasMax = filters.filter((f) => { return f.field == field[0] && f.type == '<=' });

        if (hasMax.length > 0) {
          this.table.removeFilter(hasMax[0].field, hasMax[0].type, hasMax[0].value);
        }

        if (!value) return;

        this.table.addFilter([
          { field: field[0], type: '<=', value: Number(e.target.value) }
        ]);
      }
    },
    // Number Editor and Filter Function

    // Date Editor and Filter Function
    dateRangeEditor: function(cell, onRendered, success, cancel, editorParams) {
      var container = document.createElement('div');

      // Region From
      var fromContainer = this.createDiv('', {
        display: 'flex',
        alignItems: 'center'
      });

      var fromDiv = this.createDiv('Fr', {
        display: 'flex',
        paddingRight: '3px',
        justifyContent: 'flex-end',
        fontSize: '11px'
      });

      var start = this.createInput({ type: 'date', id: `${editorParams}_start` }, {
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '11px',
        height: '20px',
        border: 'solid thin rgba(128,128,128,0.6)',
      });
      
      fromContainer.appendChild(fromDiv);
      fromContainer.appendChild(start);
      // End Region From

      // Region To
      var toContainer = this.createDiv('', {
        display: 'flex',
        alignItems: 'center'
      });

      var toDiv = this.createDiv('To', {
        display: 'flex',
        paddingRight: '3px',
        justifyContent: 'flex-end',
        fontSize: '11px'
      });

      var end = this.createInput({ type: 'date', id: `${editorParams}_end` }, {
        width: '100%',
        boxSizing: 'border-box',
        fontSize: '11px',
        height: '20px',
        border: 'solid thin rgba(128,128,128,0.6)',
      });
      
      toContainer.appendChild(toDiv);
      toContainer.appendChild(end);
      // End Region To

      container.appendChild(fromContainer);
      container.appendChild(toContainer);

      start.addEventListener('change', this.dateFiltering);
      end.addEventListener('change', this.dateFiltering);

      return container;
    },
    dateFiltering: function(e) {
      var id = e.target.id;
      var date = e.target.value;
      var field = id.split('_');

      var dateObj = new Date(date);

      var filters = this.table.getFilters();

      if (id.includes('start')) {
        var hasStart = filters.filter((f) => { return f.field == `${field[0]}_OBJ` && f.type == '>=' });
        
        if (hasStart.length > 0) {
          this.table.removeFilter(hasStart[0].field, hasStart[0].type, hasStart[0].value);
        }

        if (dateObj == 'Invalid Date') return;

        this.table.addFilter([
          { field: `${field[0]}_OBJ`, type: '>=', value: new Date(date) }
        ]);
      } else {
        var hasEnd = filters.filter((f) => { return f.field == `${field[0]}_OBJ` && f.type == '<=' });
        
        if (hasEnd.length > 0) {
          this.table.removeFilter(hasEnd[0].field, hasEnd[0].type, hasEnd[0].value);
        }

        if (dateObj == 'Invalid Date') return;

        this.table.addFilter([
          { field: `${field[0]}_OBJ`, type: '<=', value: new Date(date) }
        ]);
      }
    },
    // Date Editor and Filter Function
    createDiv: function(content, styling) {
      var div = document.createElement('div');
      Object.keys(styling).forEach((k) => {
        div.style[k] = styling[k];
      });
      div.innerHTML = content;

      return div;
    },
    createInput: function(attribute, styling) {
      var input = document.createElement('input');
      Object.keys(attribute).forEach((a) => {
        input.setAttribute(a, attribute[a]);
      });
      Object.keys(styling).forEach((k) => {
        input.style[k] = styling[k];
      });

      return input;
    },
    createSpan: function(content, styling) {
      var span = document.createElement('span');
      Object.keys(styling).forEach((k) => {
        span.style[k] = styling[k];
      });
      span.innerHTML = content;

      return span;
    },
    createImage: function(src, styling) {
      var img = document.createElement('img');
      var imgSrc = require(`@/assets${src}`);

      img.src = imgSrc;

      Object.keys(styling).forEach((k) => {
        img.style[k] = styling[k];
      });

      return img;
    },
    createButton: function(content, styling, icon) {
      var button = document.createElement('button');
      Object.keys(styling).forEach((k) => {
        button.style[k] = styling[k];
      });
      if (icon) {
        var img = document.createElement('img');
        img.src = icon;
        img.setAttribute('height', 15);
        img.setAttribute('width', 15);
        button.append(img);
        button.setAttribute('title', content);
      } else {
        button.innerHTML = content;
      }

      return button;
    },
    cellFormatter: function(cell, formatterParams) {
      if (!cell._cell) {
        // For printing section
        var myDiv = this.createDiv('', {
          display: 'flex',
          width: '100%',
          height: '100%',
          alignItems: 'center'
        });
        
        if (cell.getValue()) {
          var span = this.createSpan(cell.getValue(), {
            flexGrow: '1'
          });
          myDiv.appendChild(span);
        }
        
        return myDiv;
      }
      // formatterParams is an object that may contain 'button' or 'icon' key (Will add on more key later)
      // Creating the container
      var myDiv = this.createDiv('', {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center'
      });

      var title = cell._cell.column.titleElement.innerHTML;
      
      // Creating the span with the value in it
      if (cell.getValue()) {
        var type = typeof(cell.getValue());
        var span = this.createSpan(this.numberColumns.includes(title) ? cell.getValue().toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : cell.getValue(), {
          flexGrow: '1',
          textAlign: this.numberColumns.includes(title) ? 'right' : 'left'
        });
        myDiv.appendChild(span);
      }
      
      if (formatterParams.icon) {
        // If icon is not null or empty, insert an img
        var img = this.createImage(formatterParams.icon, { height: '20px', width: '20px' });
        myDiv.appendChild(img);
      }
      
      if (formatterParams.button) {
        // If button is not null or empty, insert button
        var button = this.createButton(formatterParams.button, {
          height: 'fit-content',
          width: 'fit-content',
          padding: '2px 5px',
          borderRadius: '3px',
          marginLeft: '5px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }, formatterParams.buttonIcon);
        button.addEventListener('click', () => {
          this.$emit('cellButtonClick', formatterParams.button, cell.getRow().getData());
          
          // Workaround for BatchBooking multirow select
          this.$emit('update:cellButtonMultiRow', this.rowSelectedPer);
          this.rowSelectedPer = [];
          //

          setTimeout(() => {
            this.clearAllSelectedRow();
            // table.getSelectedRows().forEach((r) => {
            //   console.log(r);
            // });
          }, 10);
        });
        myDiv.appendChild(button);
      }

      return myDiv;
    },
    // rowFormatter: function(row) {
      // if (row.getData().Age > 50) {
      //   row.getElement().style.backgroundColor = 'black';
      //   row.getElement().style.color = 'white';
      // }
    // },
    tableScrollToTop: function(delay) {
      var tableArea = document.getElementById(this.tableID.split(' ').join('_'));
      if (delay) {
        setTimeout(() => {
          tableArea.children[1].scrollTo(0, 0);
        }, 50);
      } else {
        tableArea.children[1].scrollTo(0, 0);
      }
    },

    // Public Methods
    selectRow: function(index) {
      setTimeout(() => {
        var allRows = this.table.getRows();
        if (typeof(index) == 'number') {
          this.table.selectRow(allRows[index]);
        } else if (typeof(index) == 'object' && Array.isArray(index)) {
          index.forEach((i) => { this.table.selectRow(allRows[i]); });
        }
      }, 25);
    },
    clearAllSelectedRow: function() {
      this.table.getSelectedRows().forEach((r) => {
        this.table.deselectRow(r);
      });
      this.$emit('update:selectedRow', []);
      
      // Workaround for BatchBooking MultiSelect
      this.rowSelectedPer = [];
      //
    },
    printDownload: function(item) {
      if (item == 'print') {
        this.table.print();
      } else if (item == 'csv') {
        this.table.download('csv', `${this.tableID.split(' ').join('_')}.csv`);
      } else if (item == 'xlsx') {
        this.table.download('xlsx', `${this.tableID.split(' ').join('_')}.xlsx`, { sheetName: this.tableID.split(' ').join('_') });
      } else if (item == 'pdf') {
        this.table.download('pdf', `${this.tableID.split(' ').join('_')}.pdf`, { orientation: 'landscape', title: this.tableID.split(' ').join('_') });
      }
    }
  },
  watch: {
    tableData: function(val) {
      this.loadTable(val);
    },
    tableDisabled: function(val) {
      // --- Adding disable area for table ---
      var tableArea = document.getElementById(this.tableID.split(' ').join('_'));
      var tableChildren = Array.from(tableArea.children);
      
      var disable = tableChildren.filter((t) => { return t.id == 'table-disabled'; });

      if (val && disable.length == 0) {
        var disableDiv = this.createDiv(val, {
          backgroundColor: 'rgba(64,64,64,0.5)',
          position: 'fixed',
          height: `calc(${tableChildren[1].clientHeight}px + 2px)`,
          width: `${tableChildren[1].clientWidth}px`,
          top: `${tableChildren[0].clientHeight}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.5em',
          fontWeight: 'bolder',
          color: 'white'
        });
        disableDiv.setAttribute('id', 'table-disabled');
        tableArea.appendChild(disableDiv);
      } else if (val && disable.length > 0) {
        disable[0].innerHTML = val;
      } else {
        tableArea.removeChild(disable[0]);
      }
    },
    headerDisabled: function(val) {
      // --- Adding disable area for header ---
      var tableArea = document.getElementById(this.tableID.split(' ').join('_'));
      var tableChildren = Array.from(tableArea.children);
      
      var disable = tableChildren.filter((t) => { return t.id == 'header-disabled'; });

      if (val && disable.length == 0) {
        var disableDiv = this.createDiv(val, {
          backgroundColor: 'rgba(64,64,64,0.5)',
          position: 'fixed',
          height: `${tableChildren[0].clientHeight}px`,
          width: '100%',
          top: 0,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fontSize: '1.5em',
          fontWeight: 'bolder',
          color: 'white'
        });
        disableDiv.setAttribute('id', 'header-disabled');
        tableArea.appendChild(disableDiv);
      } else if (val && disable.length > 0) {
        disable[0].innerHTML = val;
      } else {
        tableArea.removeChild(disable[0]);
      }
    },
    cancelAllTabIndex: function(val) {
      if (val) {
        this.clearFilters();
        setTimeout(() => { 
          var main = document.getElementById(this.tableID.split(' ').join('_'));
          var allElements = Array.from(main.getElementsByTagName('*'));

          allElements.forEach((a) => {
            a['tabIndex'] = '-1';
          });
        }, 200);
      } else {
        var main = document.getElementById(this.tableID.split(' ').join('_'));
        var allInputs = Array.from(main.getElementsByTagName('input'));
        allInputs.forEach((i) => {
          i['tabIndex'] = '1';
        });
      }
    },

    // Deprecated watch. Please use tableDisabled and headerDisabled instead
    disabled: function(val) {
      var tableArea = document.getElementById(this.tableID.split(' ').join('_')).children;
      
      var tableHolder;

      for (var i = 0; i < tableArea.length; i++) {
        if (tableArea[i].className == 'tabulator-tableHolder') {
          tableHolder = tableArea[i];
          break;
        }
      }
      
      tableHolder.style.pointerEvents = val ? 'none' : 'auto';
    },
    disableMessage: function(val) {
      var tableArea = document.getElementById(this.tableID.split(' ').join('_')).children;
      
      var tableHolder;

      for (var i = 0; i < tableArea.length; i++) {
        if (tableArea[i].className == 'tabulator-tableHolder') {
          tableHolder = tableArea[i];
          break;
        }
      }

      tableHolder.style.position = 'relative';

      if (val) {
        var onTop = this.createDiv(val, {
          backgroundColor: 'rgba(0,0,0,0.3)',
          color: 'white',
          fontSize: '2em',
          fontWeight: 'bolder',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          zIndex: 999,
          top: 0,
          left: 0,
          width: '100%',
          height: '100%'
        });

        tableHolder.appendChild(onTop);
      } else {
        var disableArea;

        for (var i = 0; i < tableArea.length; i++) {
          if (tableArea[i].className == 'tabulator-tableHolder') {
            tableHolder = tableArea[i];
            break;
          }
        }

        for (var i = 0; i < tableHolder.children.length; i++) {
          if (tableHolder.children[i].style.zIndex == 999) {
            disableArea = tableHolder.children[i];
            break;
          }
        }

        tableHolder.removeChild(disableArea);
      }
    },
  },
  mounted() {
    var tempData = this.tableData;
    this.pTableData = [];
    this.pTableData = tempData;
    this.pTableData.forEach((t) => { delete t['undefined'] });

    if (this.tableData) {
      this.loadTable(this.tableData);
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.tabulator-main {
  width: 100%;
  height: calc(100% - 37px);
  position: relative;
}

.total-records {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-end;
  font-size: 12px;
  position: relative;
}

.title-filters-area {
  width: auto;
  display: flex;
  position: absolute;
  align-items: flex-start;
  height: 38px;
  z-index: 1;
  left: 0;
}

.title-filters-area .title {
  margin-right: 10px;
  font-size: 1.2em;
  font-weight: bolder;
  align-self: center;
  display: flex;
  align-items: center;
}

.filters {
  z-index: 999;
  background-color: white;
  border: 1px solid black;
  padding: 5px;
  border-radius: 5px;
}

.filters .top {
  display: flex;
  align-items: center;
}

.show-more-btn {
  height: fit-content;
  width: fit-content;
  padding: 3px 5px;
  border-radius: 3px;
  background-color: rgb(240,240,240);
  border: 1px solid rgb(180,180,180);
  font-weight: bold;
  margin-left: 5px;
}

.show-more-btn:hover {
  background-color: rgb(180,180,180);
  color: white;
}

.filter-btn:hover {
  background-color: rgb(180,180,180);
  color: white;
}

.tabulator {
  font-size: 12px;
  width: 100%;
  height: 100%;
}

.clear-selected {
  background-color: $btn-color;
  padding: 1px 5px;
}

.button-download-print {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px;
  border-radius: 3px;

  &:hover {
    background-color: rgba(200,200,200,0.8);
  }

  > img {
    height: 15px;
  }

  > div {
    margin: 0 5px;
    font-weight: bolder;
  }
}

.download-print-menu {
  border: 1px solid black;
  border-radius: 3px;
  padding: 5px;
  font-size: 12px;

  > .print-download-menu {
    padding: 3px 5px;
    margin: 3px 0;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;

    > img {
      height: 15px;
      margin-right: 5px;
    }
    
    &:hover {
      background-color: rgba(200,200,200,0.8);
    }
  }
}
</style>